import { useEffect, useRef } from 'react';
import styled from 'styled-components'

declare global {
    interface Window {
        MicAccessTool: any;
        micAccessTool: any;
    }
}

const AccToolbox = () => {

    const initializedRef = useRef(false);

    useEffect(() => {
        if (initializedRef.current || window.micAccessTool) return;

        // Fix for double generation
        const style = document.createElement('style');
        style.innerHTML = `body #mic-init-access-tool:first-of-type {display:none !important;}
        @media (max-width: 1110px) {#mic-init-access-tool .mic-access-tool-general-button.mic-access-tool-general-button-right {bottom: 80px;}}
        @media (max-width: 768px) {#mic-init-access-tool .mic-access-tool-general-button.mic-access-tool-general-button-right {bottom: 60px;}}`;

       
        document.head.appendChild(style);
        
        const script = document.createElement('script');
        script.src = '/zugaenglichkeit/toolbar.min.js';
        script.async = true;

        script.onload = () => {
            if (initializedRef.current || window.micAccessTool) return;

            window.micAccessTool = new window.MicAccessTool({
                link: '/zugaenglichkeit/erklaerung-zur-barrierefreiheit-im-kiosk.pdf',
                contact:
                    'mailto:support@publishing.one?subject=Problem%20im%20Kunde-ePaper%20melden',
                buttonPosition: 'right',
                forceLang: 'de',
            });

            initializedRef.current = true;
        };

        document.body.appendChild(script);

        return () => {
            const existingScript = document.querySelector<HTMLScriptElement>(
                `script[src="${script.src}"]`
            );
            if (existingScript) {
                existingScript.remove();
            }
        };
    }, []);

    return null;
};

export default AccToolbox;
